import type { IconData } from '@stacksjs/iconify-core'

export const wallet: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M489.972 119.059a23.84 23.84 0 0 0-17-7.059H456V72a24.027 24.027 0 0 0-24-24H86.627A70.63 70.63 0 0 0 16 118.627v274.746A70.63 70.63 0 0 0 86.627 464h385.4a24.047 24.047 0 0 0 24-23.923l.944-303.995a23.84 23.84 0 0 0-6.999-17.023M464.053 432H86.627A38.627 38.627 0 0 1 48 393.373V118.627A38.627 38.627 0 0 1 86.627 80H424v32H88v32h376.947Z\"/><path fill=\"currentColor\" d=\"M392 264h32v32h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default wallet
